import { getWixSDK } from '../../utils/wix-sdk';
import { getCompId } from '../../utils/comp-id';
import { getInstance } from '../hydrated-data/hydrated-data';
import PAYMENT_MESSAGE_PROXY from '../../constants/payment-message-proxy';
import URL from '@wix/wix-vod-shared/dist/src/common/utils/url';
import { isGraphAPIEnabled } from '@wix/wix-vod-shared/dist/src/common/utils/experiments';

import {
  CREATE_ORDER,
  INIT_CHECKOUT,
  SELECT_METHOD,
  setError,
} from './payment.constants';
import { createAsyncProxy } from '../../worker/lib';
import { getPublicApi } from '../../api/public';
import { pubSubPublish } from '../../worker/actions/pub-sub/publish';
import EVENTS from '../../constants/events';

const getSiteDeepUrl = () =>
  getWixSDK()
    .Settings.getSiteInfo()
    .then((siteInfo) => {
      const { protocol, hostname, pathname } = new URL(siteInfo.url, {
        skipValidation: true,
      });

      return `${protocol}//${hostname}${pathname}`;
    });

export * from './payment.constants';

export function createOrder(paymentType, channelId, videoId) {
  return (dispatch, getState) => {
    const state = getState();
    const instance = getInstance(state);
    const compId = getCompId();

    dispatch(CREATE_ORDER.START({ paymentType, channelId, videoId }));
    return getSiteDeepUrl()
      .then((siteUrl) =>
        getPublicApi().purchase.createOrder(
          videoId,
          channelId,
          paymentType,
          siteUrl,
          instance,
          compId,
        ),
      )
      .then(
        (orderId) => {
          dispatch(CREATE_ORDER.SUCCESS({ orderId }));
        },
        (error) => {
          dispatch(CREATE_ORDER.FAIL(error));
          return Promise.reject(error);
        },
      );
  };
}

export const cancelOrder =
  (currentChannelId, siteUrl, instance) => async (dispatch) => {
    const publicApi = getPublicApi();
    await publicApi.purchase.cancelOrder(currentChannelId, siteUrl, instance);

    if (isGraphAPIEnabled()) {
      dispatch(
        pubSubPublish(EVENTS.PAYMENT.PAYMENT_EVENT, {
          message: {
            completed: true,
            type: PAYMENT_MESSAGE_PROXY.TYPES.SUBSCRIPTION_CANCEL,
          },
        }),
      );
    }
  };

export const selectPaymentMethod = (paymentMethod) =>
  SELECT_METHOD(paymentMethod);

export const initPayment = createAsyncProxy(
  'payment.initPayment',
  ({ paymentType, channelId, videoId }) =>
    async (dispatch) => {
      try {
        dispatch(INIT_CHECKOUT.START());
        await dispatch(createOrder(paymentType, channelId, videoId));
        dispatch(INIT_CHECKOUT.SUCCESS());
      } catch (error) {
        dispatch(INIT_CHECKOUT.FAIL(error));
        dispatch(setError(error));
      }
    },
);
